import { IRequestContractCancellationNewLinkDTO } from 'modules/customer/domain/dtos';
import { IContractCancellationsRepository } from 'modules/customer/domain/repositories';

export class RequestContractCancellationNewLinkUseCase {
  constructor(
    private contractCancellationsRepository: IContractCancellationsRepository,
  ) {}

  public async execute({
    cancellationId,
  }: IRequestContractCancellationNewLinkDTO) {
    return this.contractCancellationsRepository.requestNewLink({
      cancellationId,
    });
  }
}
